import { render, staticRenderFns } from "./BaseFormSection.vue?vue&type=template&id=282cc820&scoped=true&"
var script = {}
import style0 from "./BaseFormSection.vue?vue&type=style&index=0&id=282cc820&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282cc820",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('282cc820')) {
      api.createRecord('282cc820', component.options)
    } else {
      api.reload('282cc820', component.options)
    }
    module.hot.accept("./BaseFormSection.vue?vue&type=template&id=282cc820&scoped=true&", function () {
      api.rerender('282cc820', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BaseFormSection.vue"
export default component.exports